// Healthtech theme scripts
import { initCarousels } from './modules/carousel.js';
import { initModals } from './modules/modal.js';
import { initMobileNav } from './modules/nav-mobile.js';

const boot = () => {
  initCarousels();
  initModals();
  initMobileNav();
};

if (document.readyState !== 'loading') {
  boot();
} else {
  document.addEventListener('DOMContentLoaded', boot);
}
